import { render, staticRenderFns } from "./Redir.vue?vue&type=template&id=f9cf432e&"
import script from "./Redir.vue?vue&type=script&lang=js&"
export * from "./Redir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports